import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Dashboard from './Pages/Dashboard';
import AyudaDashboard from './Pages/AyudaDashboard';
import AyudaDashboardSeguimientoIf from './Pages/AyudadashboardSeguimientoIf';
import TablaEjemplo from './Pages/TablaEjemplo';
import Error404 from './Pages/404';
// import Login from './Auth/Login';
// import Register from './Auth/Register';
// import ForgotPasswordPage from './Auth/ForgotPassword';

// Log In
import Reedirect from './Auth/Reedirect';
import Recepcion from './Auth/Validacion';
import RecepcionToken from './Auth/ValidacionToken'

// Analista
import Asignaciones from './Pages/SeguimientoDeReclamos/MisAsignaciones';
import Ayuda from './Pages/SeguimientoDeReclamos/Ayuda';
import Buscador from './Pages/SeguimientoDeReclamos/Buscador';
import Pendientes from './Pages/SeguimientoDeReclamos/EnEsperaRespuestaPrestador';
import Reclamos from './Pages/SeguimientoDeReclamos/TodosLosReclamos';
import Derivaciones from './Pages/SeguimientoDeReclamos/Derivaciones';
import Gestionados from './Pages/SeguimientoDeReclamos/Gestionados';

//fichas tecnias

import FichasTecnicas from './Pages/FichasTecnicas/FichasMain';

//seguimiento if
import AsignacionesIf from './Pages/SeguimientoReclamosIf/MisAsignaciones';
import AyudaSeguimientoIf from './Pages/SeguimientoReclamosIf/Ayuda';
import DerivacionesIf from './Pages/SeguimientoReclamosIf/Derivaciones';
import TodosLosReclamosIf from './Pages/SeguimientoReclamosIf/TodosLosReclamos';
import ReclamosIf from './Pages/SeguimientoReclamosIf/Reclamos';
import ArbitrajesSeguimientoIf from './Pages/SeguimientoReclamosIf/Arbitrajes';
import CorreosNotificacionSeguimientoIf from './Pages/SeguimientoReclamosIf/CorreosDeNotificacion';
import MediacionesIf from './Pages/SeguimientoReclamosIf/Mediacion';

// Admin
import Usuarios from './Pages/Administracion/Usuarios';

// Urgencia Vital
import UrgenciaVital from './Pages/UrgenciaVital/TablaEjemplo';
import PersonasPorFecha from './Pages/UrgenciaVital/PersonasPorFecha';
import PersonasPorRut from './Pages/UrgenciaVital/PersonasPorRut';
import PersonasPorNombre from './Pages/UrgenciaVital/PersonasPorNombre';
import PersonasLeyRicarte from './Pages/UrgenciaVital/PersonasLeyRicarte';

//import Mediaciones from './Pages/Mediaciones/TablaEjemplo';
import Fiscalizacion from './Pages/Fiscalizacion/TablaEjemplo';

//Mediaciones
import Mediaciones from './Pages/Mediaciones/Asignaciones';
import ReclamosMediaciones from './Pages/Mediaciones/Reclamos';
import MediacionesPendientes from './Pages/Mediaciones/Pendientes';
import AyudaMediaciones from './Pages/Mediaciones/Ayuda';

import { URL_DEFAULT, URL_LOGIN, URL_VALIDACION, URL_VALIDACION_TOKEN } from '../config/config';
import { validacionApps } from '../services/service.user';
import { administracion, analista } from './routesGroups';
import EquipamientoForm from './Pages/FichasTecnicas/Components/EquipamientoForm';
import DotacionPersonalForm from './Pages/FichasTecnicas/Components/DotacionPersonalForm';
import IdentificacionPrestadorForm from './Pages/FichasTecnicas/DatosGeneralesDeIdentificacion/IdentificacionPrestador';
import EstadoAcreditacionForm from './Pages/FichasTecnicas/DatosGeneralesDeIdentificacion/Acreditacion';
//import RepresentantesForm from './Pages/FichasTecnicas/DatosGeneralesDeIdentificacion/RepresentantesLegales';
import Representantes2 from './Pages/FichasTecnicas/DatosGeneralesDeIdentificacion/RepresentantesLegales/Representantes2';
import AutorizacionSanitariaForm from './Pages/FichasTecnicas/CapacidadInstalada/AutorizacionSanitaria';

import SalasProcImagenologiaForm from './Pages/FichasTecnicas/CapacidadInstalada/SalasProcImagenologia';
import LaboratorioClinicoForm from './Pages/FichasTecnicas/CapacidadInstalada/LaboratorioClinico';
import CentroDeDialisis from './Pages/FichasTecnicas/CapacidadInstalada/CentroDeDialisis';
import CentroDeEsterilizacion from './Pages/FichasTecnicas/CapacidadInstalada/CentroDeEsterilizacion';
import Botiquin from './Pages/FichasTecnicas/CapacidadInstalada/Botiquin';
import Farmacia from './Pages/FichasTecnicas/CapacidadInstalada/Farmacia';
import PabellonCirugiaMenorYSalasProc from './Pages/FichasTecnicas/CapacidadInstalada/PabellonCirugiaMenorYSalaProc';
import TransporteDePacientes from './Pages/FichasTecnicas/CapacidadInstalada/TransporteDePacientes';

import Radioterapia from './Pages/FichasTecnicas/CapacidadInstalada/Radioterapia';
import Odontologia from './Pages/FichasTecnicas/CapacidadInstalada/Odontologia';
import AnatomiaPatologica from './Pages/FichasTecnicas/CapacidadInstalada/AnatomiaPatologica';

import BancoDeSangreUtm from './Pages/FichasTecnicas/CapacidadInstalada/BancoDeSangreUtm';
import MedicinaNuclear from './Pages/FichasTecnicas/CapacidadInstalada/MedicinaNuclear';

import CapacidadInstaladaUrgencia from './Pages/FichasTecnicas/CapacidadInstalada/Urgencia';

import Pabellones from './Pages/FichasTecnicas/CapacidadInstalada/Pabellones';

import CentroDeRehabilitacion from './Pages/FichasTecnicas/CapacidadInstalada/CentroDeRehabilitacion';
import ServiciosDeApoyo from './Pages/FichasTecnicas/CapacidadInstalada/ServiciosDeApoyo';

import CamasMedicina from './Pages/FichasTecnicas/CapacidadInstalada/Camas/categorias/CamasMedicina';

import SalasDeProcedimiento from './Pages/FichasTecnicas/CapacidadInstalada/SalasDeProcedimientos/categorias/SalasDeProcedimiento';

import VistaBaseEquipamiento from './Pages/FichasTecnicas/Equipamiento/VistaBaseEquipamiento';
import TableTemplate from './Pages/FichasTecnicas/CapacidadInstalada/TableTemplate';
import CentroMedico from './Pages/FichasTecnicas/CapacidadInstalada/CentroMedico';
import CentrosDependientes from './Pages/FichasTecnicas/CapacidadInstalada/CentrosDependientes';
import RecintoMedicinaComplementaria from './Pages/FichasTecnicas/CapacidadInstalada/RecintoMedicinaComplementaria';
import CentrolsDeRehab from './Pages/FichasTecnicas/CapacidadInstalada/CentrolsDeRehab';
import SalaDeProcedimientoMovil from './Pages/FichasTecnicas/CapacidadInstalada/SalaDeProcedimientoMovil';
import AyudaFt from './Pages/FichasTecnicas/AyudaFt';
import DirectorioDelPrestador from './Pages/FichasTecnicas/DatosGeneralesDeIdentificacion/RepresentantesLegales/DirectorioDelPrestador';
import CapacidadInstaladaUrgenciaDental from './Pages/FichasTecnicas/CapacidadInstalada/Urgencia/UrgenciaDental';
import OncologiaAlivioDolor from './Pages/FichasTecnicas/CapacidadInstalada/ServiciosDeApoyo/OncologiaAlivioDolor';
import Vacunatorio from './Pages/FichasTecnicas/CapacidadInstalada/SalasDeProcedimientos/categorias/Vacunatorio';
import EnviarFt from './Pages/FichasTecnicas/EnviarFt/inedx';
import CargaEquipamiento from './Pages/FichasTecnicas/Components/CargaEquipamientoForm';

import DotacionCargaMasiva from './Pages/FichasTecnicas/Components/DotacionCargaMasiva';
import DotacionMenuChildren from './Pages/FichasTecnicas/Components/DotacionMenuChildren';
import CargaEquipamientoProp from './Pages/FichasTecnicas/Components/CargaEquipamientoProp';
import UsersLog from './Pages/UsersLog';

const Routes = () => {
  const { authUser } = useSelector(({ auth }) => auth);
  const location = useLocation();
  const user = sessionStorage.getItem('user') || null;
  //const search = window.location.search;
  //const params = new URLSearchParams(search);
  /*   const code = params.get('code');
    const state = params.get('state');
    const tok = params.get('token'); */

  if (
    !user &&
    location.pathname !== URL_LOGIN &&
    (![URL_VALIDACION, URL_VALIDACION_TOKEN, '/test'].includes(location.pathname))
  ) {
    return <Redirect to={URL_LOGIN} />;
  }

  if ([URL_LOGIN, URL_VALIDACION, URL_VALIDACION_TOKEN].includes(location.pathname) && user) {
    return <Redirect to={URL_DEFAULT} />;
  }

  if (administracion.includes(location.pathname) && !validacionApps('Administración Extranet')) {
    return <Redirect to={URL_DEFAULT} />;
  }

  if (analista.includes(location.pathname) && !validacionApps(['Seguimiento de Reclamos', 'Fichas Técnicas'])) {
    return <Redirect to={URL_DEFAULT} />;
  }

  if (location.pathname === '' || location.pathname === '/') {
    return <Redirect to={URL_DEFAULT} />;
  } else if (authUser && location.pathname === '/signin') {
    return <Redirect to={URL_DEFAULT} />;
  }

  return (
    <React.Fragment>
      <Switch>
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/ayuda-dashboard" component={AyudaDashboard} />
        <Route path="/tabla-ejemplo" component={TablaEjemplo} />

        {/* reclamos if */}
        <Route path="/seguimientoif/asignaciones" component={AsignacionesIf} />
        <Route path="/seguimientoif/ayuda" component={AyudaSeguimientoIf} />
        <Route path="/seguimientoif/ayuda-dashboard" component={AyudaDashboardSeguimientoIf} />
        <Route path="/seguimientoif/derivaciones" component={DerivacionesIf} />
        <Route path="/seguimientoif/mediacion" component={MediacionesIf} />
        <Route path="/seguimientoif/todos" component={TodosLosReclamosIf} />
        <Route path="/seguimientoif/reclamos" component={ReclamosIf} />
        <Route path="/seguimientoif/arbitraje" component={ArbitrajesSeguimientoIf} />
        <Route path="/seguimientoif/correos" component={CorreosNotificacionSeguimientoIf} />

        {/* Log In */}
        <Route path={URL_LOGIN} component={Reedirect} />
        <Route path={URL_VALIDACION} component={Recepcion} />
        <Route path={URL_VALIDACION_TOKEN} component={RecepcionToken} />

        {/* Analista */}
        <Route path="/asignaciones" component={Asignaciones} />
        <Route path="/ayuda" component={Ayuda} />
        <Route path="/buscador" component={Buscador} />
        <Route path="/pendientes" component={Pendientes} />
        <Route path="/derivaciones" component={Derivaciones} />
        <Route path="/reclamos" component={Reclamos} />
        <Route path="/gestionados" component={Gestionados} />

        {/* fichas tecnicas */}
        <Route path="/fichas_tecnicas" component={FichasTecnicas} />
        <Route path="/ft-propuesta" component={FichasTecnicas} />
        <Route path="/ft-equipamiento" component={EquipamientoForm} />
        <Route path="/ft-dotacion-personal" component={DotacionPersonalForm} />
        <Route path="/ft-identificacion-prestador" component={IdentificacionPrestadorForm} />
        <Route path="/ft-acreditacion" component={EstadoAcreditacionForm} />
        <Route path="/ft-representantes-encargados" component={Representantes2} />
        <Route path="/ft-directorio-del-prestador" component={DirectorioDelPrestador} />
        <Route path="/ft-autorizacion-sanitaria" component={AutorizacionSanitariaForm} />
        <Route path="/ft-ayuda" component={AyudaFt} />
        <Route path="/ft-enviar" component={EnviarFt} />

        {/* dotacion de personal */}
        <Route path="/ft-dp-carga-masiva" component={DotacionCargaMasiva} />
        <Route path="/ft-dp-dotacion-personal" component={DotacionMenuChildren} />

        {/* servicios */}
        <Route path="/ft-imagenologia" component={SalasProcImagenologiaForm} /> {/* listo */}
        <Route path="/ft-laboratorio-clinico" component={LaboratorioClinicoForm} /> {/* listo */}
        <Route path="/ft-unidad-de-dialisis" component={CentroDeDialisis} /> {/* listo */}
        <Route path="/ft-centro-de-dialisis" component={CentroDeEsterilizacion} /> {/* listo */}
        <Route path="/ft-central-de-esterilizacion" component={CentroDeEsterilizacion} /> {/* listo */}
        <Route path="/ft-botiquin" component={Botiquin} /> {/* listo */}
        <Route path="/ft-farmacia" component={Farmacia} /> {/* listo */}
        <Route path="/ft-pabellon-de-cirugia-menor" component={PabellonCirugiaMenorYSalasProc} /> {/* listo */}
        <Route path="/ft-consultas-profesionales" component={PabellonCirugiaMenorYSalasProc} /> {/* listo */}
        <Route path="/ft-transporte-de-pacientes" component={TransporteDePacientes} /> {/* listo */}
        <Route path="/ft-radioterapia" component={Radioterapia} /> {/* listo */}
        <Route path="/ft-odontologia" component={Odontologia} /> {/* listo */}
        <Route path="/ft-eq-anatomia-patologica" component={AnatomiaPatologica} /> {/* listo */}
        <Route path="/ft-laboratorio-de-anatomia-patologica-y-citologia" component={AnatomiaPatologica} /> {/* listo */}
        <Route path='/ft-unidades-de-medicina-transfuncional-utm' component={BancoDeSangreUtm} /> {/* listo */}
        <Route path='/ft-unidades-de-medicina-transfuncional-umt' component={BancoDeSangreUtm} /> {/* listo */}
        <Route path="/ft-medicina-nuclear" component={MedicinaNuclear} /> {/* listo */}
        <Route path="/ft-general-indiferenciada" component={CapacidadInstaladaUrgencia} /> {/* listo */}
        <Route path="/ft-adulta" component={CapacidadInstaladaUrgencia} /> {/* listo */}
        <Route path="/ft-pediatrica" component={CapacidadInstaladaUrgencia} /> {/* listo */}
        <Route path="/ft-gineco-obstetrica-maternidad" component={CapacidadInstaladaUrgencia} /> {/* listo */}
        <Route path="/ft-dental" component={CapacidadInstaladaUrgenciaDental} /> {/* listo */}
        <Route path="/ft-escolar" component={CapacidadInstaladaUrgencia} /> {/* listo */}
        <Route path="/ft-unidad-de-pabellones" component={Pabellones} /> {/* listo */}
        <Route path="/ft-unidad-de-medicina-fisica-y-rehabilitacion" component={CentroDeRehabilitacion} /> {/* listo */}
        <Route path="/ft-unidades-donantes" component={ServiciosDeApoyo} /> {/* listo */}
        <Route path="/ft-unidad-de-oncologia-y-alivio-del-dolor" component={OncologiaAlivioDolor} /> {/* listo */}
        <Route path="/ft-central-de-alimentacion-y-sedile" component={TableTemplate} /> {/* listo */}
        <Route path="/ft-camas-basicas" component={CamasMedicina} /> {/* listo */}
        <Route path="/ft-camas-cuidados-medios" component={CamasMedicina} /> {/* listo */}
        <Route path="/ft-camas-cuidados-criticos" component={CamasMedicina} /> {/* listo */}
        <Route path="/ft-unidad-de-recuperacion" component={CamasMedicina} /> {/* listo */}
        <Route path="/ft-no-invasiva" component={SalasDeProcedimiento} />  {/* listo */}
        <Route path="/ft-invasivas" component={SalasDeProcedimiento} /> {/* listo */}
        <Route path="/ft-vacunatorio" component={Vacunatorio} /> {/* listo */}
        <Route path="/ft-centro-medico" component={CentroMedico} /> {/* listo */}
        <Route path="/ft-centro-medico-salud" component={CentroMedico} /> {/* listo */}
        <Route path="/ft-centros-dependientes" component={CentrosDependientes} /> {/* listo */}
        <Route path="/ft-centro-medico-dependiente" component={CentrosDependientes} /> {/* listo */}
        <Route path="/ft-recinto-para-el-desarrollo-de-medicina-complementarias" component={RecintoMedicinaComplementaria} /> {/* listo */}
        <Route path="/ft-centro-de-rehabilitacion-de-alcohol-y-drogas" component={CentrolsDeRehab} /> {/* listo */}
        <Route path="/ft-otros" component={Odontologia} /> {/* listo */}
        <Route path="/ft-laboratorio-dental" component={Odontologia} /> {/* listo */}
        <Route path="/ft-sala-procedimiento-movil" component={SalaDeProcedimientoMovil} /> {/* listo */}
        <Route path="/ft-sala-externa-de-toma-muestras" component={SalasDeProcedimiento} /> {/* listo */}


        {/* equipamiento */}

        <Route path="/ft-eq-carga-equipamiento" component={CargaEquipamientoProp} />
        <Route path="/ft-eq-equipamiento-odontologico" component={CargaEquipamiento} />
        <Route path="/ft-eq-equipamiento-dialisis" component={CargaEquipamiento} />
        <Route path="/ft-eq-equipamiento-imagenologia" component={CargaEquipamiento} />
        <Route path="/ft-eq-equipamiento-laboratorio" component={CargaEquipamiento} />

        {/* <Route path="/ft-eq-camas" component={VistaBaseEquipamiento} /> */}
        <Route path="/ft-eq-camas" component={CargaEquipamiento} />
        <Route path="/ft-eq-camas-medicina" component={CargaEquipamiento} />
        <Route path="/ft-eq-urgencia" component={CargaEquipamiento} />
        <Route path="/ft-eq-unidad-recuperacion" component={CargaEquipamiento} />
        <Route path="/ft-eq-pabellones" component={CargaEquipamiento} />
        <Route path="/ft-eq-salas-de-procedimientos" component={CargaEquipamiento} />
        <Route path="/ft-eq-imagenologia" component={CargaEquipamiento} />
        <Route path="/ft-eq-laboratorio-clinico" component={CargaEquipamiento} />
        <Route path="/ft-eq-farmacia" component={CargaEquipamiento} />
        <Route path="/ft-eq-botiquin" component={CargaEquipamiento} />
        <Route path="/ft-eq-central-de-esterilizacion" component={CargaEquipamiento} />
        <Route path="/ft-eq-udidad-dialisis" component={CargaEquipamiento} />
        <Route path="/ft-eq-unidad-donantes" component={CargaEquipamiento} />
        <Route path="/ft-eq-unidad-medicina-trasnfuncional" component={CargaEquipamiento} />
        <Route path="/ft-eq-unidad-oncologica-alivio" component={CargaEquipamiento} />
        <Route path="/ft-eq-radioterapia" component={CargaEquipamiento} />
        <Route path="/ft-eq-transporte-de-pacientes" component={CargaEquipamiento} />
        <Route path="/ft-eq-anatomia-patologica" component={CargaEquipamiento} />
        <Route path="/ft-eq-unidad-medicina-fisica-rehabilitacion" component={CargaEquipamiento} />
        <Route path="/ft-eq-central-alimentos-sedile" component={CargaEquipamiento} />
        <Route path="/ft-eq-odontologia" component={CargaEquipamiento} />
        <Route path="/ft-eq-medicina-nuclear" component={CargaEquipamiento} />
        <Route path="/ft-eq-equipamiento-general-hospitalario" component={CargaEquipamiento} />
        <Route path="/ft-eq-equipamiento-general-ambulatorio" component={CargaEquipamiento} />
        <Route path="/ft-eq-centro-de-dialisis" component={CargaEquipamiento} />
        <Route path="/ft-eq-centro-medico-diagnostico-salud" component={CargaEquipamiento} />
        <Route path="/ft-eq-esterilizacion" component={CargaEquipamiento} />

        {/* Administración */}
        <Route path="/usuarios" component={Usuarios} />

        {/* Mediaciones */}
        <Route path="/mediaciones" component={Mediaciones} />
        <Route path="/mediacionesReclamos" component={ReclamosMediaciones} />
        <Route path="/mediacionesPendientes" component={MediacionesPendientes} />
        <Route path="/mediacionesAyuda" component={AyudaMediaciones} />

        {/* Urgencia Vital */}
        <Route path="/urgencia-vital" component={UrgenciaVital} />
        <Route path="/urgencia-vital-fecha" component={PersonasPorFecha} />
        <Route path="/urgencia-vital-rut" component={PersonasPorRut} />
        <Route path="/urgencia-vital-nombre" component={PersonasPorNombre} />
        <Route path="/urgencia-vital-ricarte" component={PersonasLeyRicarte} />

        {/* Fizcalizacion */}
        <Route path="/fiscalizacion" component={Fiscalizacion} />

        {/* Users Log */}
        <Route path="/users_log" component={UsersLog} />

        <Route component={Error404} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
